import 'scss/solutions/smart-city.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'

$(function () {
  var swiper = []
  swiper[0] = new Swiper('#smart-city-swiper-1', {
    autoplay: 2000,
    loop: true
  })
  swiper[1] = new Swiper('#smart-city-swiper-2', {
    autoplay: 2000,
    loop: true
  })
  swiper[2] = new Swiper('#smart-city-swiper-3', {
    autoplay: 2000,
    loop: true
  })
  swiper[3] = new Swiper('#smart-city-swiper-4', {
    autoplay: 2000,
    loop: true
  })
  $('.solutions-item-case .case-tabs li').on('click', function () {
    $('.solutions-item-case .case-tabs li').removeClass('active')
    $(this).addClass('active')
    $('.solutions-item-case .solutions-item-content li').removeClass('active')
    $('.solutions-item-case .solutions-item-content li').eq($(this).data('index')).addClass('active')
    swiper[$(this).data('index')].init()
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/solutions/smart-city.js